import {
  translationControllerGetDictionary,
  translationControllerGetVersion,
} from "@/shared/api/generated.ts"

export const getDictionary = async (lang: string) => {
  try {
    return await translationControllerGetDictionary(lang)
  } catch (e) {
    console.error(e)
    return null
  }
}

export const getDictionaryVersion = async (): Promise<number | null> => {
  try {
    return (await translationControllerGetVersion()).version
  } catch (e) {
    console.error(e)
    return null
  }
}
